
import Vue from 'vue';
import { APP_ERROR_EVENT } from '../../../../constants';
import { Core } from '../../../../services/core';
import { LightSourcePartEntity, LightSourcePartsStore } from '../../../../services/parts';

export default Vue.extend({
  name: 'partsLightSourcesView',
  data() {
    return {
      isMounted: false,
      isLoading: false,

      metadata: {
        light_source: undefined as LightSourcePartEntity | undefined,
      },
    };
  },

  beforeMount() {
    this.$metronic.breadcrumbs.setBreadcrumbs([
      { title: 'Parts', route: '/parts' },
      { title: 'Light sources', route: '/parts/light-sources' },
    ]);
  },

  async mounted() {
    this.$set(this, 'isLoading', true);
    try {
      const [light_source] = await Promise.all([
        LightSourcePartsStore.get(this.$route.params.guid),
      ]);

      this.$set(this.metadata, 'light_source', light_source);
    } catch (e) {
      console.error(e);
      Core.Eventhub.emit(APP_ERROR_EVENT, e);
      return;
    } finally {
      this.$set(this, 'isMounted', true);
      this.$set(this, 'isLoading', false);
    }

    this.$metronic.breadcrumbs.appendBreadcrumb({
      title: this.metadata.light_source?.description as string,
    });
  },
});
